export const removeAbbreviationEntities = (content: Draft.RawDraftContentState, entityIndex: string): void => {
  for (const block of (content.blocks)) {
    block.entityRanges = block.entityRanges.filter(range => range.key.toString() !== entityIndex);
  }

  delete content.entityMap[entityIndex];
};
